import ComboCards from "./ComboCards";
import { useCallback } from "react";
import ViewAll from "../UI-item,viewAll,BtmSheet/ViewAll";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import { closeCatDD } from "../../../../../Redux/Reducer/dropdown";
import { useQuery } from "react-query";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
const url = process.env.React_App_Api_url;

const getProducts = async (param) => {
  try {
    const response = await fetch(`${url}/${param}`);
    let resResult = await response.json();
    // if (!resResult.length) {
    //   const backup = await fetch(`${url}/backup`);
    //   resResult = await backup.json();
    // }
    return resResult;
  } catch (error) {
    console.log("REQUEST FAILED AT GET PRODUCT", error);
  }
};

const Combo = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { t } = useTranslation();

  const navigateTo = useCallback(() => {
    navigate("/Combos");
    dispatch(closeCatDD());
  }, []);

  const {
    data: products,
    isLoading: productLoading,
    isError: productError,
  } = useQuery([`CATALOGUE_COMBOS`], () =>
    getProducts("plp/combos").then((res) => res["Combos"]?.products)
  );
  // console.log(products);

  // ---------------------MAIN JSX---------------------------
  return productLoading ||
    productError ||
    !products ||
    !products.length ? null : (
    <div className="card-wrap combo-wrap">
      <div className="d-flex align-items-center justify-content-between sec-title">
        <div>
          <h2>{t("Budget Combos")}</h2>
          <h4>{t("Buy More, Save More")}</h4>
        </div>
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            navigateTo();
          }}
        >
          {t("View all ")}
          <i className="bi bi-chevron-right"></i>
        </a>
      </div>
      <div className="horiz-scroll">
        <ComboCards products={products.slice(0, 10)} />
        <ViewAll
          items={products.slice(products.length - 3, products.length)}
          navigateTo={navigateTo}
        />
      </div>
    </div>
  );
};
export default Combo;
